import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/styles/index.css'
import App from './App'
import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://6ce8bbba31f820f67d29d6f4ab00d0b9@o4508783825911808.ingest.de.sentry.io/4508789577351248',
  sendDefaultPii: !process.env.NODE_ENV,
  environment: process.env.NODE_ENV,
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a div with id="root" in your HTML.'
  )
}

const root = ReactDOM.createRoot(rootElement)
root.render(<App />)
